import React from 'react'
import { Tab } from 'semantic-ui-react'
import RegisterBP from './RegisterBP';
import BPLaporan from './BPLaporan';
import BPLaporan2 from './BPLaporan2';
import RekeningLaporan from './RekeningLaporan';
// import PenerimaanRek from './PenerimaanRek';
// import RegisterSTS from './RegisterSTS';
// import SPJPendapatan from './SPJPendapatan';
// import BPHarian from './BPHarian';

const panes = [
   { 
      menuItem: 'REGISTER BP', 
      render: () => <Tab.Pane attached={false}><RegisterBP /></Tab.Pane> 
   },
   { 
      menuItem: 'LAPORAN', 
      render: () => <Tab.Pane attached={false}><BPLaporan /></Tab.Pane> 
   },
   { 
      menuItem: 'LAPORAN 2', 
      render: () => <Tab.Pane attached={false}><BPLaporan2 /></Tab.Pane> 
   },
   { 
      menuItem: 'LAPORAN REKENING', 
      render: () => <Tab.Pane attached={false}><RekeningLaporan /></Tab.Pane> 
   },
   // { 
   //    menuItem: 'PENERIMAAN REKENING', 
   //    render: () => <Tab.Pane attached={false}><PenerimaanRek /></Tab.Pane> 
   // },
   // {
   //    menuItem: 'REGISTER STS',
   //    render: () => <Tab.Pane attached={false}><RegisterSTS /></Tab.Pane>
   // },
   // {
   //    menuItem: 'SPJ PENDAPATAN ADMINISTRATIF',
   //    render: () => <Tab.Pane attached={false}><SPJPendapatan /></Tab.Pane>
   // },
   // {
   //    menuItem: 'REKAPITULASI PENERIMAAN HARIAN',
   //    render: () => <Tab.Pane attached={false}><BPHarian /></Tab.Pane>
   // },
]

const ReportIndex = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default ReportIndex;


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_report_admin/ReportIndex.js